import React from "react";
import Tooltip from "@mui/material/Tooltip";
export const StyledTooltip = (props: any) => {
    return (
        <Tooltip {...props} classes={{ popper: "custom-tooltip" }} arrow />
    );
};